import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import "./AddPurchase.css";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

const AddJobWorker = () => {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    city: "",
    pin_code: "",
    phoneNo: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required";
    // if (!formData.address.trim()) newErrors.address = "Address is required";
    // if (!formData.city.trim()) newErrors.city = "City is required";
    // if (!formData.pin_code || !/^\d{6}$/.test(formData.pin_code)) 
    //   newErrors.pin_code = "Valid 6-digit pin code is required";
    if (!formData.phoneNo || !/^\d{10}$/.test(formData.phoneNo)) 
      newErrors.phoneNo = "Valid 10-digit phone number is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setErrors({});
    setSubmitError(null);
    setLoading(true);

    const payload = {
      name: formData.name,
      mobile: formData.phoneNo,
      city: formData.city,
      address: formData.address,
      pincode: formData.pin_code
    };

    try {
      const response = await api.post("/job_worker_add.php", payload);
      
      if (response.data.head.code === 200) {
        const workerId = response.data.body.id;
        alert(`Worker added successfully! Worker ID: ${workerId}`);
        
        setFormData({
          name: "",
          address: "",
          city: "",
          pin_code: "",
          phoneNo: "",
        });
         navigate("/jobworker");
      } else {
        setSubmitError(response.data.head.msg || "Failed to add worker");
        alert(`Error: ${response.data.head.msg}`);
      }
    } catch (err) {
      console.error("Error adding worker:", err);
      setSubmitError("Failed to add worker. Please try again.");
      alert("Failed to add worker. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Job Worker</h4>
        <Button className="btn-top" onClick={() => window.history.back()}>Back</Button>
      </div>

      {submitError && (
        <div className="alert alert-danger" role="alert">
          {submitError}
        </div>
      )}

      {successMessage && (
        <div className="alert alert-success" role="alert">
          {successMessage}
        </div>
      )}

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Worker Name *</Form.Label>
              <Form.Control
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter worker name"
                isInvalid={!!errors.name}
                disabled={loading}
              />
              {renderError("name")}
            </Form.Group>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Phone Number *</Form.Label>
              <Form.Control
                name="phoneNo"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={10}
                value={formData.phoneNo}
                onChange={handleChange}
                placeholder="10-digit phone number"
                isInvalid={!!errors.phoneNo}
                disabled={loading}
              />
              {renderError("phoneNo")}
            </Form.Group>
          </Col>

          <Col lg={12}>
            <Form.Group>
              <Form.Label>Address *</Form.Label>
              <Form.Control
                name="address"
                as="textarea"
                rows={2}
                value={formData.address}
                onChange={handleChange}
                placeholder="Enter complete address"
                isInvalid={!!errors.address}
                disabled={loading}
              />
              {renderError("address")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>City *</Form.Label>
              <Form.Control
                name="city"
                type="text"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                isInvalid={!!errors.city}
                disabled={loading}
              />
              {renderError("city")}
            </Form.Group>
          </Col>

          <Col lg={4} md={6} sm={12}>
            <Form.Group>
              <Form.Label>Pin Code *</Form.Label>
              <Form.Control
                name="pin_code"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength={6}
                value={formData.pin_code}
                onChange={handleChange}
                placeholder="6-digit pin code"
                isInvalid={!!errors.pin_code}
                disabled={loading}
              />
              {renderError("pin_code")}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <Button 
            type="submit" 
            className="btn-submit"
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Adding...
              </>
            ) : (
              "Submit"
            )}
          </Button>
          <Button 
            type="button" 
            className="btn-top" 
            onClick={() => window.history.back()}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AddJobWorker;